import styled from 'styled-components';
import { Box } from '@components/Box';
import { Columns } from '@components/Columns';
import { CloudImage } from '@components/CloudImage';
import { TextPairing } from '@components/TextPairing';
import { themeColor, themeMediaQuery, themeSpace } from '@utils/styledTheme.util';
import { GetStartedButton } from '@components/GetStartedButton/GetStartedButton';

export const Container = styled(Box)`
  background: linear-gradient(180deg, ${themeColor('yellow1')}, ${themeColor('yellow2')});
  ${themeMediaQuery('below_sm')} {
    padding-top: ${themeSpace(0)};
  }
`;
export const StyledConnectedGuestList = styled(CloudImage)`
  width: 100%;
  ${themeMediaQuery('lg')} {
    width: 1025px;
    display: block;
    margin: 0 auto;
  }
`;

export const StyledGetStartedButton = styled(GetStartedButton)`
  background: transparent;
`;

export const TextPairingWrapper = styled(TextPairing)`
  .text-pairing-title {
    max-width: 650px;
  }
  ${themeMediaQuery('below_sm')} {
    .text-pairing-title {
      max-width: 370px;
    }
  }
  ${themeMediaQuery('xl')} {
    .text-pairing-title {
      max-width: 870px;
    }
  }
`;

export const AnimationContainer = styled(Box)`
  width: 100%;
  overflow: hidden;
`;

export const Lottie = styled(Box)`
  position: relative;
  width: 100%;
  height: 100%;
  display: block;
  overflow: hidden;
  transform: translate3d(0, 0, 0);
  text-align: center;
  opacity: 1;
  margin-top: -381px;
  ${themeMediaQuery('below_sm')} {
    margin-top: unset;
  }
`;

export const ColumnWrapper = styled(Columns.Column)`
  display: flex;
  flex-direction: column;
  ${themeMediaQuery('below_sm')} {
    flex-direction: column-reverse;
  }
`;
